import { createClient } from "@supabase/supabase-js";

/**
 * Cliente Supabase — SOLO para la auth del vertical operaciones (/evergreen).
 *
 * El vertical operaciones lo atiende el Engine nuevo (api2.aliadigital.co) que
 * autentica con JWT de Supabase (Bearer), NO con el session_token del backend
 * viejo. El resto del portal (inbox, etc.) sigue con su login de siempre
 * (lib/api.ts + lib/auth.ts) — este cliente no lo toca.
 *
 * `storageKey` propio para no pisar "alia.session" del login viejo.
 */
const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const anon = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

export const supabase =
  url && anon
    ? createClient(url, anon, {
        auth: {
          persistSession: true,
          autoRefreshToken: true,
          detectSessionInUrl: true,
          storageKey: "alia.evergreen.supabase",
        },
      })
    : null;
